import VRadioGroup from './VRadioGroup'
import VRadio from './VRadio'

export { VRadioGroup, VRadio }

export default {
  $_ifrontui_subcomponents: {
    VRadioGroup,
    VRadio,
  },
}
